import {SET_LIMPIAR_PARAMETROS, SET_PARAMETROS_BUSQUEDA} from "../actions/busqueda/busquedaAction";

const initialState = {
    cvetda: '',
    oprcaj: '',
    importe: '',
    folioSVA: '',
    serieFac: '',
    folioFac: '',
    fecha: new Date()
};

const setParametrosBusqueda = (state = initialState, action) => {
    switch (action.type) {
        case SET_PARAMETROS_BUSQUEDA:
            return {
                ...state,
                ...action.payload
            };
        case SET_LIMPIAR_PARAMETROS:
            return {
                ...state,
                ...initialState
            };
        default:
            return state;
    }
};

export default setParametrosBusqueda;